import { useEffect, useRef, useState } from "react";

const OBSERVER_OPTIONS = {
  threshold: 0.12,
  rootMargin: "0px 0px -40px 0px",
};

export const useScrollReveal = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      OBSERVER_OPTIONS
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return { ref, visible };
};
